"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CursorType = void 0;
var CursorType;
(function (CursorType) {
    CursorType["Ticketing"] = "Ticketing";
    CursorType["Organization"] = "Organization";
})(CursorType || (exports.CursorType = CursorType = {}));
